import { Shadow, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import { calculatePercentageWidth, widthCols } from '../../../constants';

export const LoadingItemDesktop: React.FC = () => {
  return (
    <Shadow
      key={'customer-table-skeleton'}
      level={2}
      borderRadius={BoxRadius.sm}
      testId="customer-table-list">
      <HStack
        px={Spacing['inline.xxxs']}
        py={Spacing['inline.xxs']}
        alignItems={'center'}
        borderRadius={BoxRadius.sm}>
        <VStack
          width={`${calculatePercentageWidth(widthCols.name)}%`}
          space={Spacing['inline.quarck']}>
          <Skeleton
            w={'80%'}
            h={Typography['fontsize.md']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <HStack alignItems={'center'} space={Spacing['inline.quarck']}>
            <Skeleton
              w={Spacing['inline.xxxs']}
              h={Spacing['inline.xxxs']}
              borderRadius={'full'}
              endColor={Color['brand.primary.lightest']}
            />
            <Skeleton
              w={Spacing['inline.xxxs']}
              h={Spacing['inline.xxxs']}
              borderRadius={'full'}
              endColor={Color['brand.primary.lightest']}
            />
          </HStack>
        </VStack>
        <VStack width={`${calculatePercentageWidth(widthCols.cpfCnpjFormatted)}%`}>
          <Skeleton
            w={'60%'}
            h={Typography['fontsize.md']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </VStack>
        <VStack width={`${calculatePercentageWidth(widthCols.accountNumber)}%`}>
          <Skeleton
            w={'30%'}
            h={Typography['fontsize.md']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </VStack>
        <VStack width={`${calculatePercentageWidth(widthCols.suitabilityProfileName)}%`}>
          <Skeleton
            w={'50%'}
            h={'26px'}
            borderRadius={'full'}
            endColor={Color['brand.primary.lightest']}
          />
        </VStack>
        <VStack width={`${calculatePercentageWidth(widthCols.registrationStatusName)}%`}>
          <Skeleton
            w={'40%'}
            h={Typography['fontsize.md']}
            borderRadius={'full'}
            endColor={Color['brand.primary.lightest']}
          />
        </VStack>
        <VStack width={`${calculatePercentageWidth(widthCols.availableBalance)}%`}>
          <Skeleton
            w={'60%'}
            h={Typography['fontsize.md']}
            borderRadius={'full'}
            endColor={Color['brand.primary.lightest']}
          />
        </VStack>
        <VStack width={`${calculatePercentageWidth(widthCols.buttonSelectCustomer)}%`}>
          <Skeleton
            w={'full'}
            h={'40px'}
            borderRadius={'full'}
            endColor={Color['brand.primary.lightest']}
          />
        </VStack>
      </HStack>
    </Shadow>
  );
};
